export default {
    install(Vue, options){
        Vue.prototype.$encryptData = (data)=>{
            const encryptionKey = localStorage.getItem('encryptionKey')
            return Vue.prototype.CryptoJS.AES.encrypt(
                JSON.stringify(data),
                encryptionKey
            ).toString()
        }
        Vue.prototype.$decryptData = (data, parseJSON = true)=>{
            const encryptionKey = localStorage.getItem('encryptionKey')
            let decryptData = Vue.prototype.CryptoJS.AES.decrypt(data, encryptionKey).toString(Vue.prototype.CryptoJS.enc.Utf8)
            return parseJSON ? JSON.parse(decryptData) : decryptData;
        }

        /**
         * Check if user is logged in (has valid auth token)
         * @returns {boolean} - true if user is authenticated
         */
        Vue.prototype.$isLoggedIn = ()=>{
            const token = localStorage.getItem('vueauth_token')
            return !!token && token !== 'null' && token !== 'undefined' && token !== 'false'
        }

        /**
         * Get the current authentication token from localStorage
         * @returns {string|null} - The vueauth_token or null if not logged in
         */
        Vue.prototype.$getAuthToken = ()=>{
            const token = localStorage.getItem('vueauth_token')
            return (!!token && token !== 'null' && token !== 'undefined' && token !== 'false')
                ? token
                : null
        }
    }
}